/**
 * Normalisation defensive des rows cee_documents :
 *  - le serveur peut envoyer snake_case (doc_type, is_current, mime_type, size_bytes)
 *  - ou camelCase si un mapper applicatif est en place (docType, isCurrent, ...)
 *
 * Codex review S2.6 P1 : DocumentsSection filtrait sur `docType` mais les rows
 * S1 renvoyaient `doc_type`. Resultat : aucun doc reconnu, tout en "manquant".
 *
 * Cette fonction unifie en camelCase, fallback gracieux si champ absent.
 *
 * @typedef {object} NormalizedDoc
 * @property {string} id
 * @property {string} docType
 * @property {string} status
 * @property {boolean} isCurrent
 * @property {string | null} filename
 * @property {string | null} mimeType
 * @property {number | null} sizeBytes
 * @property {string | null} source
 */

/**
 * @param {object | null | undefined} row
 * @returns {NormalizedDoc | null}
 */
export function normalizeDocument(row) {
  if (!row) return null;
  const docType = row.docType ?? row.doc_type;
  if (!docType) return null;
  return {
    id: String(row.id),
    docType: String(docType),
    status: String(row.status || 'manquant'),
    isCurrent: row.isCurrent !== undefined ? Boolean(row.isCurrent)
      : row.is_current !== undefined ? Boolean(row.is_current)
        : true,
    filename: row.filename ?? null,
    mimeType: row.mimeType ?? row.mime_type ?? null,
    sizeBytes: row.sizeBytes ?? row.size_bytes ?? null,
    source: row.source ?? null,
  };
}

/**
 * Normalise une liste, filtre les nulls.
 * @param {Array<object> | null | undefined} rows
 * @returns {Array<NormalizedDoc>}
 */
export function normalizeDocuments(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map(normalizeDocument).filter((d) => d !== null);
}
